import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import EslBanner from "../components/site/EslBanner";
import About from "../components/site/About";
import MissionVision from "../components/site/MissionVision";
import Programs from "../components/site/Programs";
import Retreats from "../components/site/Retreats";
import Testimonials from "../components/site/Testimonials";
import DiscoveryCall from "../components/site/DiscoveryCall";
import Booking from "../components/site/Booking";
import BlogPreview from "../components/site/BlogPreview";
import Newsletter from "../components/site/Newsletter";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <Hero />
      <EslBanner />
      <About />
      <MissionVision />
      <Programs />
      <Retreats />
      <Testimonials />
      <DiscoveryCall />
      <Booking />
      <BlogPreview />
      <Newsletter />
      <Contact />
      <Footer />
    </div>
  );
}
